import React, { Component } from 'react';
import { Container } from 'shards-react';
export default class FilesDashboard extends Component {
  render() {
    return (
      <Container fluid className='h-100 my-3'>
        <h1>Hello</h1>
      </Container>
    );
  }
}
